import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { PageContent, Container, Pagination, FiltersControls, BoxList, Spinner } from 'components';
import {
  loadSearchCreator,
  setSearchPageCreator,
  setSearchPerPageCreator,
} from 'store/actionsCreators';
import { connect } from 'react-redux';
import { globalPropTypes, isLoading } from 'helpers';
import { useTranslation } from 'react-i18next';

const Events = ({ loading, searchValue, loadList, setPage, setPerPage, list }) => {
  const { t } = useTranslation();

  const { items, page, pages, perPage } = list;

  useEffect(() => {
    loadList(searchValue);
  }, [searchValue]);

  useEffect(() => {
    setPage(1);
    loadList(searchValue);
  }, [perPage]);

  return (
    <PageContent>
      <Container>
        {loading ? <Spinner /> : null}
        {!loading ? (
          <>
            <FiltersControls
              perPageSelected={perPage}
              perPageOnChange={(payload) => setPerPage(payload.value)}
            />
            <BoxList type="event" items={items} alert={t('global.noResultsFound')} />
            <Pagination
              styled
              currentPage={page}
              totalPages={pages}
              onChange={(payload) => {
                setPage(payload);
                loadList(searchValue);
              }}
            />
          </>
        ) : null}
      </Container>
    </PageContent>
  );
};

Events.propTypes = {
  loading: PropTypes.bool,
  loadList: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setPerPage: PropTypes.func.isRequired,
  searchValue: PropTypes.string,
  list: globalPropTypes.ListPropsTypes.isRequired,
};

Events.defaultProps = {
  loading: false,
  searchValue: '',
};

const mapStateToProps = ({ loading, search: { events: list } }) => ({
  loading: isLoading(loading, 'LOAD_SEARCH_EVENTS'),
  list,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: (payload) => dispatch(loadSearchCreator('events', payload)),
  setPage: (payload) => dispatch(setSearchPageCreator('events', payload)),
  setPerPage: (payload) => dispatch(setSearchPerPageCreator('events', payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Events);
